module.exports = __webpack_public_path__ + "img/allume-logo.e9133bfe.png";